import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Buffer } from 'buffer';

import App from './App.tsx';
import QueryProvider from './providers/QueryProvider.tsx';
import { AuthProvider } from './providers/AuthProvider.tsx';
import './globals.css';
import 'bootstrap/dist/css/bootstrap.min.css';

window.Buffer = Buffer;

// Environment logging handled by Vite in development
// This is disabled during tests

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId="639007308170-lcrsao9lgj3km159oo6uj2sjhs8tbrb8.apps.googleusercontent.com">
      <BrowserRouter>
        <AuthProvider>
          <QueryProvider>
            <App />
          </QueryProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </StrictMode>,
);
